import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import NuDate from "../../../../Components/Utils/NuDate";
import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Progress } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import FilesView from "../../../../Components/Utils/FilesView";
import { NuInput } from "../../../../Components/Utils/Input";
import ScheduleLayout from "./ScheduleLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";

function ViewSheduleTesting(onClose) {
  const { scheduleViewId } = useParams();
 

  const location = useLocation();
  const cdata = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);
   const [createNew, setCreateNew] = useState({
    name:""
  });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };


  const [data,setData] = useState(cdata? cdata:null); 
  
 
  

  function getView() {
    axiosInstance 
      .get(`/tc-schedules/${scheduleViewId}`)
      .then((res) => {
        setData(res.data?.data);       
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    if (!cdata) {
      getView();
    }
  }, [scheduleViewId])

   const formInputs = [
    {
      title:"form1",
      updatedOn:"12-03-2025",
      completion:'30',
      status:'open',
       formInputs : [
        {
          inputType: "NuInput",
          name: "projectName",
          label: "Project Name",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Project Name",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "refNo",
          label: "Ref. No",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Ref. No",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "location",
          label: "Location",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Downtown, NY",
          customClass: "w-full",
        },
        {
          inputType: "NuDate",
          datename: "date",
          label: "Date",
          dateclassname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "FormikSelectTwo",
          name: "mainContractor",
          label: "Main Contractor.",
          type: "text",
          Options: [
            { label: "Dr. Smith", value: "dr_smith" },
            { label: "Dr. Johnson", value: "dr_johnson" },
            { label: "Dr. Lee", value: "dr_lee" },
          ],
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Main Contractor",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "FormikSelectTwo",
          name: "consultant",
          label: "Consultant",
          type: "text",
          Options: [
            { label: "Dr. Smith", value: "dr_smith" },
            { label: "Dr. Johnson", value: "dr_johnson" },
            { label: "Dr. Lee", value: "dr_lee" },
          ],
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Consultant",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "poEqNumber",
          label: "PO/EQ #",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "PO12345",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuDate",
          datename: "date",
          label: "Date",
          dateclassname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "salesPerson",
          label: "Sales Person",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Jane Smith",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "inspector",
          label: "Inspector",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "Mike Johnson",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "FormikSelectTwo",
          name: "serviceType",
          label: "Service Type",
          Options: [
            { value: "contractual", label: "Contractual" },
            { value: "non-contractual", label: "Non-Contractual" },
            { value: "one-time", label: "One Time Service" },
          ],
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "FormikSelectTwo",
          name: "workScope",
          label: "Scope of Work",
          Options: [
            { value: "new-installation", label: "New Installation" },
            { value: "fit-out-work", label: "Fit Out Work" },
            { value: "maintenance-repair", label: "Maintenance/Repair" },
          ],
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "FormikSelectTwo",
          name: "systemType",
          label: "System Type",
          Options: [
            { value: "fire-fighting", label: "Fire Fighting" },
            { value: "fire-alarm", label: "Fire Alarm" },
            { value: "fire-suppression", label: "Fire Suppression" },
          ],
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "mainLineSize",
          label: "Main Line Size",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "6 inches",
          customClass: "w-full lg:w-6/12",
        },
        {
          inputType: "NuInput",
          name: "tappingPointSize",
          label: "Tapping Point Size",
          type: "text",
          classname: "border w-full h-10 px-3 mt-2 rounded-3xl",
          placeholder: "3 inches",
          customClass: "w-full lg:w-6/12",
        },
      ]
      
         
    },
    
   
  ];
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
   
    onSubmit: (values) => console.log("Form Submitted", values),
  });

 const [filePathList, setFilePathList] = useState([]);
 
   useEffect(() => {
     if (
       data?.attachments !== null &&
       data?.attachments !== "None" &&
       data?.attachments !== "[]"
     ) {
       setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
     }
   }, [data]);
  
  return (
    <ScheduleLayout 
    EditAccess={GetAccess("testing_and_commisioning_module")}
          BackAccess={GetAccess("testing_and_commisioning_module")}
    >
    <div className="w-full h-full mt-0.5 overflow-y-auto  ">
      {/* <div className="flex justify-end ">
        <div className=" flex gap-2">
          <Link
            to={`/testingAndcommisioning/schedules`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <Link
            to={`/testingAndcommisioning/schedules/edit/${scheduleViewId}`}
            state={{
              data: data,
              from: `/testingAndcommisioning/schedules/view/${scheduleViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div>
      </div> */}

      <div className="w-full mx-auto h-[calc(100vh-175px)]  rounded-md    md:flex gap-2 text-[#111537]">
        <div className="md:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
            <div className="grid  items-center ">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[90%]">
                <p className="flex">Ref: {data?.refNumber}</p>
              </div>
              <div className="flex gap-4 justify-between">
              <p className="text-xs text-[#111537]">
                  Date :{" "}
                  {data?.date ? (
                    <NuDate value={data?.date} format="DD-MMM-YYYY, hh:mm A" />
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>
            </div>

            <div className="border rounded-md mr-3 border-textColor-main sm:mt-0 mt-2 text-xs inline-flex w-auto  flex-shrink-0  justify-center">
              <p className="  bg-white  text-black  p-1 rounded-l-md  ">
                Status{" "}
              </p>
              <p className="bg-textColor-main text-white p-1 items-center rounded-r-md">
                {" "}
                {data?.status || "None"}
              </p>
            </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">
              <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Type
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.type}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Project Name
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.projectName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Contractor
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.mainContractorName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Consultant
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.consultantName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Supplier
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.supplierName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Installer
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.installerName}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Conductors
                  </p>
                  <p className="py-2 text-xs font-medium text-[#606279] flex">
                    :
                  {data?.conductors?.map((conductors) => (
                  <p className="text-xs font-medium text-[#606279] ">
                     {conductors.assigneeName},
                  </p>
                  ))}
                  </p>

                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Location
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.location}
                  </p>
                </div>
           
               
              
              </div>
            
            </div>

            <div className="sm:flex gap-4 mt-4">
              <div className="sm:w-[50%] ">
                <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                                  
                                  <div className="w-full flex gap-2 flex-wrap ">
                                    {data?.attachments &&
                                      filePathList.map((imgs, idx) => {
                                        console.log("img", imgs);
                                        return (
                                          <FilesView fileView={imgs} key={idx} />
                                        );
                                      })}
                                  </div>
                                </div>
              </div>
              
            </div>



          </div>
        </div>
        <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
          <div className="w-full grid  border border-gary   rounded-lg">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Client Detail</p>
              </div>
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.clientName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Reference
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.clientRefNumber}
                </p>
              </div>
            </div>

            <div className="w-full grid  border border-gary mt-4  rounded-lg ">
              <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                Forms{" "}
              </p>
              <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                <div
                  onClick={[]}
                  className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                >
                  <svg
                    width="20"
                    height="20"
                    fill="#3369ff"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                  </svg>
                  <p className="w-auto text-[10px]">
                    {data?.ref || "Shedule form"}
                  </p>
                </div>
              </div>
            </div>

            <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.pId}
                addurl={"/pr-comments/new-coment"}
                // geturl={`/pr-comments/by-PR/${data?.prd}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </ScheduleLayout>
  );
}

export default ViewSheduleTesting;
